import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import { Box, Divider, Skeleton, Stack } from "@mui/material";

export function LoadingStandAloneChat() {
  return (
    <Stack
      borderRadius={2}
      boxShadow={2}
      direction="column"
      width="100%"
      sx={{ overflow: "hidden" }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} p={2}>
        <Skeleton variant="circular" width={40} height={40} />
        <Stack spacing={0.5}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={80} height={16} />
        </Stack>
      </Stack>

      <Divider />

      <Box sx={{ minHeight: "200px", maxHeight: "500px", p: 2 }}>
        <Stack spacing={1.5}>
          <Box sx={{ alignSelf: "flex-start", maxWidth: "60%" }}>
            <Skeleton
              variant="rounded"
              width={200}
              height={40}
              sx={{ borderRadius: 2 }}
            />
          </Box>
          <Box sx={{ alignSelf: "flex-end", maxWidth: "60%" }}>
            <Skeleton
              variant="rounded"
              width={160}
              height={40}
              sx={{ borderRadius: 2 }}
            />
          </Box>
          <Box sx={{ alignSelf: "flex-start", maxWidth: "60%" }}>
            <Skeleton
              variant="rounded"
              width={240}
              height={56}
              sx={{ borderRadius: 2 }}
            />
          </Box>
          <Box sx={{ alignSelf: "flex-end", maxWidth: "60%" }}>
            <Skeleton
              variant="rounded"
              width={180}
              height={40}
              sx={{ borderRadius: 2 }}
            />
          </Box>
        </Stack>
      </Box>

      <Divider />

      <Stack direction="row" alignItems="center" spacing={1} p={1.5}>
        <Skeleton variant="circular" width={32} height={32}>
          <AttachFileIcon />
        </Skeleton>
        <Skeleton
          variant="rounded"
          height={36}
          sx={{ borderRadius: 4, flex: 1 }}
        />
        <Skeleton variant="circular" width={32} height={32}>
          <SendIcon />
        </Skeleton>
      </Stack>
      <Box sx={{ px: 1.5, pb: 1 }}>
        <Skeleton variant="text" width={140} height={14} />
      </Box>
    </Stack>
  );
}
